import angular from 'angular';

import { FormDirective } from './form.directive';

angular.module('core.directives.form', []).directive('form', FormDirective);
